export const resolveOwnerScopedAccountId = (accountId?: number): number => {
  if (typeof window === 'undefined') {
    return Number(accountId || 0);
  }

  const ownerAccountId = Number(localStorage.getItem('ownerAccountId') || '0');
  if (Number.isInteger(ownerAccountId) && ownerAccountId > 0) {
    return ownerAccountId;
  }

  if (Number(accountId) > 0) {
    return Number(accountId);
  }

  return Number(localStorage.getItem('accountId') || '0');
};
